import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'era-devices-unassigned-badge-ui',
  templateUrl: './devices-unassigned-badge.component.html',
  styleUrls: ['./devices-unassigned-badge.component.scss'],
  imports: [RouterLink],
})
export class DevicesUnassignedBadgeComponent {
  @Input() count: number;
}
